import React, { useRef, useState, useEffect } from "react";
import "../styles/SetSection.css";
import { useDispatch } from "react-redux";
import { SetPopupReducerData } from "../store/reducer/PopupReducer";
import { useParams } from "react-router-dom";
import EventLineDrawer from "../Components/popup/DrawEvent";
import {
  GetExistingEvent,
  setEventRecord,
  UpdateEventCamera,
  UseCaseeventListApi,
} from "../api/api";
import { toast } from "react-toastify";
import { IoIosArrowBack } from "react-icons/io";
import axios from "axios";

const MultiplePolygon = () => {
  const dispatch = useDispatch();
  const id = useParams();
  const [drawingEnabled, setDrawingEnabled] = useState(false);
  const [drawMode, setDrawMode] = useState("line");
  const [isDrawing, setIsDrawing] = useState(false);
  const [lines, setLines] = useState([]); // multiple lines/polygons
  const [currentLine, setCurrentLine] = useState([]);
  const [lastLine, setLastLine] = useState(null);
  const [draggingPointIndex, setDraggingPointIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [useCase, setUseCase] = useState([]);
  const [lineOrientation, setLineOrientation] = useState(null);
  const [showDirectionSelect, setShowDirectionSelect] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [inputData, setInputData] = useState({ use_case: "" });
  const [restrictedSide, setRestrictedSide] = useState("");
  const [name, setName] = useState("");
  const imageRef = useRef(null);
  const canvasRef = useRef(null);
  const audioRef = useRef(null);
  const [isedit, setIsEdit] = useState(false);
  const [eventId, setEventId] = useState("");
  const [employeeName, setEmployeeName] = useState("");

  const FetchDetailEvent = async () => {
    try {
      const fetchData = await GetExistingEvent(id?.id);
      const event = fetchData?.data?.data?.[0];
      setEventId(event?._id);
      if (event?.coordinates && event?.coordinates.length > 0) {
        const formattedPoints = event.coordinates.map(([x, y]) => ({ x, y }));
        setLines([
          {
            points: formattedPoints,
            orientation: "inside",
            direction: "left",
          },
        ]);
        setIsEdit(true);
        setDrawMode(event.shape_type || "polygon");
        setDrawingEnabled(true);
      }
    } catch (error) {
      console.error("Fetch event error", error);
    }
  };

  const getCanvasPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
  };

  const fetchUseCase = async () => {
    try {
      const data = await UseCaseeventListApi();
      if (data?.data?.status === true) {
        setUseCase(data?.data?.data);
      }
    } catch (error) {
      console.error("Fetch usecase error", error);
    }
  };

  useEffect(() => {
    fetchUseCase();
    FetchDetailEvent();
  }, [id?.id]);

  const handleDrawClick = () => {
    setDrawingEnabled(true);
    setCurrentLine([]);
  };

  const handleMouseDown = (e) => {
    const pos = getCanvasPos(e);
    if (!drawingEnabled) return;

    if (drawMode === "line") {
      setIsDrawing(true);
      setCurrentLine([pos]);
    } else {
      setCurrentLine((prev) => [...prev, pos]);
    }
  };

  const handleMouseMove = (e) => {
    if (!isDrawing || !drawingEnabled) return;
    setCurrentLine((prev) => [...prev, getCanvasPos(e)]);
  };

  const handleMouseUp = () => {
    if (!drawingEnabled) return;

    if (drawMode === "line" && currentLine.length > 1) {
      const start = currentLine[0];
      const end = currentLine[currentLine.length - 1];
      const dx = Math.abs(end.x - start.x);
      const dy = Math.abs(end.y - start.y);
      const orientation = dx > dy ? "horizontal" : "vertical";

      const lineData = {
        points: [start, end],
        orientation: "inside",
        direction: "left",
      };

      setLines((prev) => [...prev, lineData]);
      setLastLine({ x1: start.x, y1: start.y, x2: end.x, y2: end.y });
      setLineOrientation(orientation);
      setShowDirectionSelect(true);
      setCurrentLine([]);
    }

    setIsDrawing(false);
  };

  const handleCompletePolygon = async () => {
    if (drawMode === "polygon" && currentLine.length >= 3) {
      if (!employeeName.trim()) {
        toast.warn("Please enter a name for the polygon.");
        return;
      }

      const polygonPoints = currentLine.map((p) => [
        Math.round(p.x),
        Math.round(p.y),
      ]);

      const camera_url = localStorage.getItem("rtsp_url");

      // Save polygon with label
      setLines((prev) => [
        ...prev,
        {
          points: [...currentLine],
          orientation: "inside",
          direction: "left",
          label: employeeName.trim(), // ✅ Store label
        },
      ]);

      setCurrentLine([]);
      setName(""); // ✅ Clear name after drawing
    } else {
      toast.warn("Please draw at least 3 points to complete the polygon.");
    }
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = 2;
    ctx.strokeStyle = "#00AEEF";
    ctx.font = "14px Arial";
    ctx.fillStyle = "white";
    ctx.textBaseline = "top";

    lines.forEach((line, index) => {
      const points = line.points;
      if (!points || points.length < 2) return;

      // Draw the shape
      ctx.beginPath();
      ctx.moveTo(points[0].x, points[0].y);
      points.forEach((p, i) => {
        if (i > 0) ctx.lineTo(p.x, p.y);
      });

      if (drawMode === "polygon") ctx.closePath();
      ctx.stroke();

      // Draw points
      points.forEach((pt) => {
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 4, 0, 2 * Math.PI);
        ctx.fillStyle = "blue";
        ctx.fill();
      });

      // ✅ Draw event name label
      if (line.label) {
        const labelX = points[0].x + 5;
        const labelY = points[0].y + 5;
        ctx.fillStyle = "#000000aa"; // background with alpha
        const textWidth = ctx.measureText(line.label).width;
        ctx.fillRect(labelX - 2, labelY - 2, textWidth + 4, 18);
        ctx.fillStyle = "#ffffff"; // white text
        ctx.fillText(line.label, labelX, labelY);
      }
    });

    // Draw in-progress shape
    if (currentLine.length > 0) {
      ctx.beginPath();
      currentLine.forEach((point, index) => {
        index === 0
          ? ctx.moveTo(point.x, point.y)
          : ctx.lineTo(point.x, point.y);
      });
      ctx.stroke();
    }
  }, [lines, currentLine, name, drawMode]);

  const handleSubmit = async () => {
    if (!lines.length) return toast.warn("No shape drawn!");
    if (!inputData.use_case) return toast.warn("Please select a use case.");
    setLoading(true);

    try {
      const lastShape = lines[lines.length - 1];
      const coordinates = lastShape.points.map((point) => [
        Math.round(point.x),
        Math.round(point.y),
      ]);
      const payload = {
        camera_id: id?.id,
        coordinates,
        shape_type: drawMode,
        action_type_ids: [],
        alert_type_ids: [],
        usecase_id: inputData.use_case,
        restricted_type: restrictedSide,
        event_name: name,
      };

      const response = await setEventRecord(payload);
      if (response?.data?.status) {
        setShowDrawer(false);
        toast.success("Event saved successfully!");
      } else toast.error("Something went wrong!");
    } catch (err) {
      toast.error("Error saving event!");
    } finally {
      setLoading(false);
    }
  };

  const handlePolygonSubmit = async () => {
    if (!lines.length)
      return toast.warn("Please draw at least one polygon before submitting.");
    if (!inputData.use_case) return toast.warn("Please select a use case.");

    const camera_url = localStorage.getItem("rtsp_url");

    try {
      const payload = {
        camera_id: id?.id,
        camera_url: camera_url,
        polygon_coords: lines.map((shape) => ({
          name: employeeName,
          polygon: shape.points.map((pt) => [
            Math.round(pt.x),
            Math.round(pt.y),
          ]),
        })),
        employee_name: employeeName, // You can make this dynamic if needed
      };

      const response = isedit
        ? await UpdateEventCamera(payload)
        : await setEventRecord(payload);

      if (response?.data?.status) {
        toast.success(
          isedit
            ? "Polygons updated successfully!"
            : "Polygons saved successfully!"
        );
        setShowDrawer(false);
        setLines([]);
      } else {
        toast.error("Something went wrong while saving polygons.");
      }
    } catch (error) {
      console.error("Polygon submit error:", error);
      toast.error("Something went wrong while submitting polygons.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="entranceGroup">
        <IoIosArrowBack size={22} /> Camera / Entrance Group
      </div>
      <div className="container mt-5">
        <div className="image-area-wrapper">
          <div
            className="image-container"
            ref={imageRef}
            style={{ position: "relative", width: "960px", height: "540px" }}
          >
            <img
              src={`https://visionemptrack.greymatterz.com/stream2/stream2/${
                id.id
              }?t=${Date.now()}`}
              alt="Camera Feed"
              className="camera-image"
            />
            {drawingEnabled && (
              <canvas
                ref={canvasRef}
                width={960}
                height={540}
                style={{ position: "absolute", top: 0, left: 0 }}
                onMouseDown={handleMouseDown}
                onMouseMove={handleMouseMove}
                onMouseUp={handleMouseUp}
              />
            )}
          </div>

          <audio ref={audioRef} src="/alert.mp3" preload="auto" />

          <div className="button-group">
            <button className="action-btn" onClick={() => setShowDrawer(true)}>
              Add Event
            </button>

            <button
              className="action-btn"
              onClick={() => {
                setDrawingEnabled(false);
                dispatch(
                  SetPopupReducerData({
                    modalType: "setalert",
                    showModal: true,
                    camera_id: id?.id,
                  })
                );
              }}
            >
              Set Alert
            </button>
            <button
              className="action-btn"
              onClick={() => {
                setDrawingEnabled(false);
                dispatch(
                  SetPopupReducerData({
                    modalType: "setaction",
                    showModal: true,
                  })
                );
              }}
            >
              Set Action
            </button>
          </div>
        </div>

        {showDrawer && (
          <EventLineDrawer
            onClose={() => setShowDrawer(false)}
            onSubmit={(data) => {
              handleSubmit();
              setShowDrawer(false);
            }}
            handleDrawClick={(mode) => {
              setDrawMode(mode);
              handleDrawClick();
            }}
            useCaseId={inputData.use_case}
            setUseCaseId={(value) =>
              setInputData((prev) => ({ ...prev, use_case: value }))
            }
            restrictedSide={restrictedSide}
            setRestrictedSide={setRestrictedSide}
            lineOrientation={lineOrientation}
            showDirectionSelect={showDirectionSelect}
            setShowDirectionSelect={setShowDirectionSelect}
            setName={setName}
            name={name}
            drawMode={drawMode}
            currentLine={currentLine}
            handleCompletePolygon={handleCompletePolygon}
            isName={false}
            handlePolygonSubmit={handlePolygonSubmit}
            setEmployeeName={setEmployeeName}
            employeeName={employeeName}
          />
        )}
      </div>
    </>
  );
};

export default MultiplePolygon;
